import React, { useState } from 'react';
import clsx from 'clsx';
import { ContentArea } from '../ContentArea/ContentArea';

import { mapMarginPaddingArrayToObject } from '@/utils/helperFunc';
import { useNode } from '@craftjs/core';
import { NodePaddingSettingsV2 } from '../PaddingMarginFields/NodePaddingSettingsV2';
import { useBreakpointAwareProp } from '@/hooks/useBreakpointAwareProp';
import type { ContainerProps } from '@builder4/shared/components/Container';
import { MAX_PADDING } from '@builder4/shared/utils/constants';
import { clampPadding } from '@builder4/shared/components/Page';
import { useAppSelector } from '@/store/hooks';
import { selectBreakpoint } from '@/store/system/selectors';

interface ContentAreaFullProps {
  className?: string;
  onClick?: () => void;
  text?: string;
  icon?: React.ComponentType<React.SVGProps<SVGSVGElement>>;
}

export const ContentAreaFull: React.FC<ContentAreaFullProps> = ({
  className = '',
  text = 'Publish',
}) => {
  const { props, displayName } = useNode((node) => ({
    props: node.data.props as ContainerProps,
    displayName: node.data.displayName,
  }));
  const { getBPProp } = useBreakpointAwareProp(displayName);
  const breakpoint = useAppSelector(selectBreakpoint);
  const [type, setType] = useState<'padding' | 'default'>('padding');

  const padding = getBPProp(props, 'padding') || [0, 0, 0, 0];
  const value = mapMarginPaddingArrayToObject(clampPadding(padding, MAX_PADDING[breakpoint]));

  return (
    <div className={clsx(className, 'flex flex-col gap-3')}>
      <p className="pb-1 text-xs font-semibold text-neutral-900">Layout</p>

      <ContentArea className="" padding={value} text={text} state={type} />
      <NodePaddingSettingsV2
        value={value}
        onFocus={() => setType('padding')}
        onBlur={() => setType('default')}
      />
    </div>
  );
};
